import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import PortfolioPage from './pages/PortfolioPage';
import PortalPage from './pages/PortalPage';
import ServicesPage from './pages/ServicesPage';
import FAQPage from './pages/FAQPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import LegalPage from './pages/LegalPage';
import NotFoundPage from './pages/NotFoundPage';
import CookieBanner from './components/CookieBanner';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-background overflow-x-clip">
          {/* Grain overlay for texture */}
          <div className="grain" />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:slug" element={<PortalPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/privacy" element={<LegalPage />} />
            <Route path="/terms" element={<LegalPage />} />
            <Route path="/imprint" element={<LegalPage />} />
            <Route path="/legal/:page" element={<LegalPage />} />
            {/* Unbekannte Adressen: Server sendet 404, hier die sichtbare Seite */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>

          <CookieBanner />
          <Toaster position="bottom-right" theme="light" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
